import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import { CSVLink } from "react-csv";

import { useHistory, useParams } from "react-router-dom";
import Header from "../../../components/Headers/Header";
import { Button, Card, CardBody, CardHeader, Container } from "reactstrap";
import { ArrowRight } from "react-bootstrap-icons";
import { STATE_OFFICIAL_PATHS } from "../../../routes";
import { IWeeklyAvgTeacherUsage } from "../../../types";
import {
  weeklyAvgTeacherUsage,
  weeklyAvgTeacherUsagelt1hrs,
  weeklyAvgTeacherUsagelt2hrs,
} from "./../../../coustomJson/Avg_teacher_app_usage";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";

type IData = {
  employId: string;
  name: string;
  schoolName: string;
  schoolCode: string;
  district: string;
};

export default function TopTeacher() {
  const path = useParams();
  const history = useHistory();
  const [data, setData] = useState<IWeeklyAvgTeacherUsage[]>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    console.log("Params: ", path?.name);
    setDataOnParams();
    let timer = setTimeout(() => setIsLoading(false), 6000);

    return () => clearTimeout(timer);
  }, []);

  const setDataOnParams = () => {
    path?.name == "overall"
      ? setData(weeklyAvgTeacherUsage)
      : path?.name == "lt1hrs"
      ? setData(weeklyAvgTeacherUsagelt1hrs)
      : path?.name == "lt2hrs"
      ? setData(weeklyAvgTeacherUsagelt2hrs)
      : console.log("");
  };

  const headers = [
    { label: "Employ Id", key: "employId" },
    { label: "Name", key: "name" },
    { label: "School Name", key: "schoolName" },
    { label: "School Code", key: "schoolCode" },
    { label: "District", key: "district" },
  ];
  return (
    <React.Fragment>
      <Header />
      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <div className="d-flex justify-content-between">
              <h3 className="mb-0 text-muted">
                <i className="fas fa-file-invoice mr-1"></i> Top 10 State
                Teachers
              </h3>
              <div>
                <div>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() =>
                      history.push(STATE_OFFICIAL_PATHS.stateOfficerDashboard)
                    }
                  >
                    Go Back <ArrowRight />
                  </Button>
                </div>
              </div>
            </div>
          </CardHeader>
          {isLoading ? (
            <div className="" style={{ height: "300px" }}>
              <DotsSpinner />
            </div>
          ) : (
            <CardBody>
              <div className="d-flex flex-wrap">
                <Table className="w-100" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th className="px-2">Employ Code</th>
                      <th className="px-4">Name</th>
                      <th className="px-2">School </th>
                      <th className="px-2">Block</th>
                      <th className="px-2">District</th>
                      <th className="px-2">Usage in mins</th>
                    </tr>
                  </thead>
                  {data.map((e: IWeeklyAvgTeacherUsage) => (
                    <tr>
                      <td>{e.emp_code}</td>
                      <td>{e.name}</td>
                      <td>{e.school}</td>
                      <td>{e.block}</td>
                      <td>{e.district}</td>
                      <td>{e.usage_in_mins}</td>
                    </tr>
                  ))}
                </Table>
              </div>
            </CardBody>
          )}
        </Card>
      </Container>
    </React.Fragment>
  );
}
